const Share = (props) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.3261 9.50617C17.5296 9.3318 17.6313 9.24461 17.6686 9.14086C17.7013 9.0498 17.7013 8.9502 17.6686 8.85914C17.6313 8.75539 17.5296 8.6682 17.3261 8.49383L10.2672 2.44331C9.917 2.14315 9.74191 1.99306 9.59367 1.98939C9.46483 1.98619 9.34177 2.04279 9.26035 2.14269C9.16667 2.25764 9.16667 2.48825 9.16667 2.94948V6.52886C7.38777 6.84007 5.75966 7.74146 4.54976 9.09489C3.23069 10.5704 2.50103 12.48 2.5 14.4591V14.9691C3.37445 13.9157 4.46626 13.0638 5.70063 12.4716C6.78891 11.9495 7.96535 11.6403 9.16667 11.5588V15.0505C9.16667 15.5117 9.16667 15.7424 9.26035 15.8573C9.34177 15.9572 9.46483 16.0138 9.59367 16.0106C9.74191 16.0069 9.917 15.8569 10.2672 15.5567L17.3261 9.50617Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Share;
